import { handleActions } from 'redux-actions';
import * as actions from '../actions/parametrosPago.action';

const initialState = {
  loading: false,
  parametros: null,
  error: null,
};

const ParametrosPagoReducer = handleActions(
  {
    [actions.setLoadingParametrosPagoAction]: (state, { payload }) => {
      return { ...state, loading: payload };
    },
    [actions.setParametrosPagoAction]: (state, { payload }) => {
      return { ...state, parametros: payload };
    },
    [actions.setErrorParametrosPagoAction]: (state, { payload }) => {
      return { ...state, error: payload };
    },
    [actions.resetStateParametrosPagoAction]: (state, { payload }) => {
      return { ...initialState };
    },
  },
  initialState,
);

export default ParametrosPagoReducer;
